<template>
  <div class="template-table">
    <div v-for="(content, key) in content.acf.content" :key="key">
      <div v-if="content.acf_fc_layout === 'simple_table_3_cols'" class="mb-5">
        <div v-html="content.text_before_table" class="text-md mb-4"></div>
        <div class="responsive-table">
          <table class="table table-simple">
            <tr>
              <th>
                <img v-if="content.col_1_header.icon_instead_of_text"
                      :src="content.col_1_header.icon"/>
                <span v-else-if="content.col_1_header.text"
                      :style="{'color': content.col_1_header.custom_text_color}">
                  {{content.col_1_header.text}}
                </span>
              </th>
              <th>
                <img v-if="content.col_2_header.icon_instead_of_text"
                      :src="content.col_2_header.icon"/>
                <span v-else-if="content.col_2_header.text"
                      :style="{'color': content.col_2_header.custom_text_color}">
                  {{content.col_2_header.text}}
                </span>
              </th>
              <th>
                <img v-if="content.col_3_header.icon_instead_of_text"
                      :src="content.col_3_header.icon"/>
                <span v-else-if="content.col_3_header.text"
                      :style="{'color': content.col_3_header.custom_text_color}">
                  {{content.col_3_header.text}}
                </span>
              </th>
            </tr>
            <tr v-for="(row, i) in content.rows" :key="i">
              <td :style="{
                'background-color': content.col_1_settings.background_color,
                'width': `${content.col_1_settings.width}%`
              }">
                <div v-html="row.col_1" :style="{'color': content.col_1_settings.text_color}"></div>
              </td>
              <td :style="{
                'background-color': content.col_2_settings.background_color,
                'width': `${content.col_2_settings.width}%`
              }">
                <div v-html="row.col_2" :style="{'color': content.col_2_settings.text_color}"></div>
              </td>
              <td :style="{
                'background-color': content.col_3_settings.background_color,
                'width': `${content.col_3_settings.width}%`
              }">
                <div v-html="row.col_3" :style="{'color': content.col_3_settings.text_color}"></div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: Object,
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/common.scss';
.table-simple {
  th {
    text-align: center;
    vertical-align: middle!important;
    border-top: 0!important;
    font-weight: normal;
    font-size: 1rem;
    img {
      max-width: 60px;
    }
  }
  tr {
    td {
      width: 33%;
      vertical-align: middle!important;
      > div {
        padding: 15px 0;
      }
      p:last-child, ul:last-child {
        margin: 0;
      }
      ul {
        > li:last-child {
          margin: 0;
        }
        @extend .list-square;
      }
    }
  }
}
@include media-breakpoint-down(md) {
  .responsive-table {
    overflow: auto;
    width: 100%;
    .table-simple {
      width: 690px;
    }
  }
}
</style>
